"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getSelectedBlock;
function getSelectedBlock(editorState) {
    var currentContent = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    return currentContent.getBlockForKey(selection.getStartKey());
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-utils@0.1.0@rc-editor-utils/lib/getSelectedBlock.js
// module id = 45
// module chunks = 0 1 2